module.exports = "<section id=\"page-container\" class=\"app-page-container\">\r\n    <my-app-header></my-app-header>\r\n    <div>\r\n        <div class=\"container-fluid\">\r\n            <router-outlet></router-outlet>\r\n        </div>\r\n    </div>\r\n    <my-app-footer></my-app-footer>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// ./src/app/user-management/user-management.component.html
// module id = 1101
// module chunks = 1